import { Checkbox, type CheckboxProps } from '@progress/kendo-react-inputs'
import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Box } from '~/components/elements/Box'
import { type NineSegment, nineSegmentAttributeI18nKeyMap } from '~/utils'

import styles from './NineSegmentCheckbox.css'

export type NineSegmentCheckboxProps = {
  checked: boolean
  className: string
  nineSegment: NineSegment
  onChange: (nineSegment: NineSegment, checked: boolean) => void
}

export const NineSegmentCheckbox = ({
  checked,
  className,
  nineSegment,
  onChange,
}: NineSegmentCheckboxProps) => {
  const { t } = useTranslation()

  const handleChange = React.useCallback<EH<CheckboxProps, 'onChange'>>(
    (event) => {
      onChange(nineSegment, event.value)
    },
    [nineSegment, onChange],
  )

  return (
    <Box className={classNames(styles.root, className)}>
      <Checkbox
        checked={checked}
        className={styles.checkbox}
        label={t(nineSegmentAttributeI18nKeyMap[nineSegment])}
        labelClassName={styles.label}
        onChange={handleChange}
      />
    </Box>
  )
}
